<template>
  <div>
    <v-container fluid>
      <v-row dense class="pb-1">
        <v-col cols="3">
          <date-range :from.sync="from" :to.sync="to" v-model="dateDisplay" @change="refresh()" option="Last 30 days" hide-details/>
        </v-col>
        <v-col cols="3">
          <v-autocomplete label="Sales Representative" dense outlined :items="salesReps" item-value="id" item-text="name" v-model="salesRepId" hide-details  @change="refresh()"/>
        </v-col>
        <v-col cols="2">
          <v-autocomplete label="Show customer" dense outlined :items="['Name','Type','Category']" v-model="by" hide-details @change="refresh()"/>
        </v-col>
        <v-col cols="3">
          <multi-level-select :menuData="customerMenu" :first.sync="customerType" :second.sync="customerId" outlined label="Customer" @change="refresh()" hide-details/>
        </v-col>
        <v-col class="text-right pr-2">
          <v-btn icon @click="printHtml('Sales commissions details', buildReport())"><v-icon>mdi-printer</v-icon></v-btn>
          <v-tooltip bottom open-delay="1000" v-if="company.allowCSVExport">
            <template v-slot:activator="{on}">
              <v-btn icon @click="exportCSV" v-on="on"><v-icon>mdi-download</v-icon></v-btn>
            </template>
            Export as CSV file
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="3">
          <multi-level-select label="Item" :menuData="itemsList" :first.sync="type" :second.sync="id" caption outlined @change="refresh()" hide-details no-validation/>
        </v-col>
        <v-col cols="2">
          <v-autocomplete label="Product units" dense outlined :items="unitsList" v-model="units" hide-details @change="refresh()"/>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 228px)">
      <span v-html="buildReport()"/>
    </v-card>

  </div>
</template>

<script>
import fileSaver from 'file-saver';
import printHtml from '@/mixins/printHtml'
import createHierarchyList from '@/mixins/createHierarchyList'
import customerTypes from '@/mixins/customerTypes'

export default {
  name: 'ReportsSalesRepsDetails',
  mixins: [customerTypes,printHtml,createHierarchyList],
  data() {
    return {
      from: null,
      to: null,
      customerType: '0',
      by: 'Name',
      dateDisplay: '',
      salesReps: [{name:'All',id:null},{divider:true}],
      salesRepId: null,
      types: [],
      customerMenu: [{name:'All',id:'0'},{divider:true}],
      customerId: null,
      itemsList: [{name:'All',id:''},{divider:true}],
      unitsList: [{text:'bottles',value:'bottles'},{text:'units',value:'sellingUnits'},
                  {text:'cases',value:'cases'},{text:'pallets',value:'pallets'},
                  {text:'litres',value:'litres'},{text:'laa',value:'laa'}],
      units: 'bottles',
      type: '',
      id: '',
      loading: true,
      report: []
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  },
  async created() {
    this.$emit('name', 'Sales commissions details')
    const productCategories = [];
    const itemCategories = [];
    const products = [];
    const items = [];
    const bundles = [];
    const spirits = [];
    const wines = [];
    const nonExcises = [];
    const customerCategories = [];
    const data = await Promise.all([
      this.$store.dispatch('customers', true),
      this.buildCustomerTypes(),
      this.$lazyListLoad(customerCategories, 'categories2', 'id,name', 100, [], [{name:'type',value:'Customer'}]),
      this.$lazyListLoad(productCategories, 'categories2', 'id,name,parent{id}', 100, [], [{name:'type',value:'Product'}]),
      this.$lazyListLoad(itemCategories, 'categories2', 'id,name,parent{id}', 100, [], [{name:'type',value:'Item'}]),
      this.$lazyListLoad(products, 'products2', 'id,name,category{id}', 100, [{field:'active', comparator:'eq', value:'true'}]),
      this.$lazyListLoad(bundles, 'bundles2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]),
      this.$lazyListLoad(items, 'items2', 'id,name,category{id}', 100, [{field:'active', comparator:'eq', value:'true'},{field:'sold', comparator:'eq', value:'true'}]),
      this.$lazyListLoad(spirits, 'spirits2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]),
      this.$lazyListLoad(wines, 'wines2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]),
      this.$lazyListLoad(nonExcises, 'nonExcises2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}])
    ]);
//    this.customers.push(...data[0]);
    this.$lazyListLoad(this.salesReps, 'salesReps2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);

    this.itemsList.push({name:'Product',id:'Product',menu:this.menuForProducts(products, productCategories)});
    if (bundles.length)
      this.itemsList.push({name:'Bundle',id:'Bundle',menu:bundles});
    if (items.length) {
      if (itemCategories.length) {
        const categories = this.createHierarchyList(itemCategories);
        for (const category of categories) {
          const sub = items.filter(item => item.category?.id === category.id);
          if (sub.length)
            category.menu = sub;
          else
            category.disabled = true;
        }
        this.itemsList.push({name:'Item',id:'Item',menu:categories});
        const leftOver = items.filter(item => !item.category?.id);
        if (leftOver.length)
          this.itemsList[this.itemsList.length-1].menu.push({divider:true},{name:'Other items',id:'x',menu:leftOver});
      }
      else
        this.itemsList.push({name:'Item',id:'Item',menu:items});
    }
    this.itemsList.push({name:'Spirit', id:'Spirit',menu:spirits});
    if (wines.length)
      this.itemsList.push({name:'Wine', id:'Wine',menu:wines});
    if (nonExcises.length)
      this.itemsList.push({name:'Non-excise', id:'NonExcise',menu:nonExcises});

    if (this.$route.query.from && this.$route.query.to) {
      this.from = this.$route.query.from;
      this.to = this.$route.query.to;
    }
    this.salesRepId = this.$route.query.salesRepId ?? null;

    this.customerMenu.push({name:'Name',id:'1',menu:data[0]});
    this.customerMenu.push({name:'Type',id:'2',menu:data[1].map(type => ({name:type.text,id:type.value})).filter(type => type.id)});
    if (customerCategories.length)
      this.customerMenu.push({name:'Category',id:'3',menu:customerCategories});
  },
  methods: {
    menuForProducts(products, productCategories) {
      if (productCategories.length) {
        const categories = this.createHierarchyList([...productCategories]);
        for (const category of categories) {
          const sub = products.filter(product => product.category?.id === category.id);
          if (sub.length)
            category.menu = sub;
          else
            category.disabled = true;
        }
//        const p = [...categories.filter(category => !category.disabled)];
        const p = categories;
        const leftOver = products.filter(product => !product.category?.id);
        if (leftOver.length)
          p.push({divider:true},{name:'Other products',id:'x',menu:leftOver});
        return p;
      }
      else
        return products;
    },
    async refresh() {
      this.loading = true;
      const results = await this.$apiCall(`query ReportsSalesRepsDetails($input:SalesRepDetailReportInput!) {
                                              salesRepDetailReport(input:$input) {
                                                salesRepName,commissionPercent
                                                invoices {
                                                  customerName,date,invoiceNumber
                                                  lines {
                                                    item,amount,commissionExempt
                                                    units,precision,product
                                                    quantity,bottles,sellingUnits,cases,pallets,litres,laa
                                                  }
                                                }
                                              }
                                            }`,
                                          {input:{from:this.from,to:this.to,salesRepId:this.salesRepId,
                                                  customerId:this.customerType==='1'?this.customerId:null,
                                                  customerType:this.customerType==='2'?this.customerId:null,
                                                  customerCategoryId:this.customerType==='3'?this.customerId:null,
                                                  by:this.by,
                                                  itemId:this.type ? this.id : null}});
      if (!results.error)
        this.report = results.data.salesRepDetailReport;
      this.loading = false;
    },

    buildReport() {
      const lines = [
                  `<style>
                    @page {size:landscape}
                    .report {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px}
                    .report th {height:36px;padding:0 16px;vertical-align:middle}
                    .report .spacer {height:18px}
                    .report td {height:36px;padding:0 16px;vertical-align:middle}
                    .report .title {font-size:18px;text-transform:uppercase}
                    .report .sub-title {font-weight:normal;height:inherit;padding-bottom:20px;font-size:14px}
                    .report .header th {border-bottom:1px solid #000;margin-bottom:20px}
                    .report .text-left {text-align:left}
                    .report .text-right {text-align:right}
                    .report .font-weight-bold {font-weight:bold}
                    .report .line-top {border-top:thin solid black}
                    .report .double-line-top {border-top:2px double black}
                  </style>
                   <table class="report">
                     <thead>
                        <tr>
                          <th colspan="6" class="sup-title">${this.company.name}</th>
                        </tr>
                        <tr>
                          <th colspan="6" class="title">
                            Sales commissions details
                            ${this.salesRepId ? `for ${this.salesReps.find(r => r.id === this.salesRepId).name}` : ''}
                          </th>
                        </tr>
                        <tr>
                           <th colspan="6" class="sub-title">
                            ${this.dateDisplay}
                          </th>
                        </tr>
                        <tr class="header">
                          <th width="21%" class="text-left">Sales Representative / Customer</th>
                          <th width="12%" class="text-left">Date</th>
                          <th width="10%" class="text-left">Invoice</th>
                          <th width="20%" class="text-left">Item</th>
                          <th width="15%" class="text-right">Quantity</th>
                          <th width="10%" class="text-right">Sale</th>
                          <th width="10%" class="text-right">Commission</th>
                        </tr>
                      </thead>
                      <tbody>`];

      let grandTotalSale = 0;
      let grandTotalCommission = 0;
      for (const salesRep of this.report) {
        let totalSale = 0;
        let totalCommission = 0;
        lines.push(`<tr>
                      <td colspan="6" class="font-weight-bold">${salesRep.salesRepName} - ${this.$number(salesRep.commissionPercent,2)}%</td>
                    </tr>`);

        for (const invoice of salesRep.invoices) {
          let totalInvoiceSale = 0;
          let totalInvoiceCommission = 0;
          lines.push(`<tr>
                        <td>${invoice.customerName}</td>
                        <td>${this.$formatDate(invoice.date)}</td>
                        <td>${invoice.invoiceNumber}</td>`);
          let lineNumber = 0;
          for (const line of invoice.lines) {
            totalInvoiceSale += line.amount;
            const commission = line.commissionExempt ? 0 : line.amount * salesRep.commissionPercent / 100;
            totalInvoiceCommission += commission;
            lines.push(`  <td>${line.item}</td>`);
            if (line.product)
              lines.push(`<td class="text-right">${this.$number(line[this.units],line.precision)} ${this.unitsList.find(unit => unit.value === this.units).text}</td>`);
            else
              lines.push(`<td class="text-right">${this.$number(line.quantity,line.precision)} ${line.units}</td>`);
            lines.push(`  <td class="text-right">${this.$number(line.amount,2)}</td>
                          <td class="text-right">${this.$number(commission,2)}</td>
                        </tr>`);
            if (lineNumber++ < invoice.lines.length-1)
              lines.push(`<tr><td colspan=3"/>`);
          }
          lines.push(`<tr>
                        <td colspan="5"/>
                        <td class="text-right font-weight-bold">${this.$number(totalInvoiceSale,2)}</td>
                        <td class="text-right font-weight-bold">${this.$number(totalInvoiceCommission,2)}</td>
                      </tr>`);
          totalSale += totalInvoiceSale;
          totalCommission += totalInvoiceCommission;
        }
        grandTotalSale += totalSale;
        grandTotalCommission += totalCommission;
        lines.push(`<tr>
                      <td colspan="5"/>
                      <td class="text-right font-weight-bold line-top">${this.$number(totalSale,2)}</td>
                      <td class="text-right font-weight-bold line-top">${this.$number(totalCommission,2)}</td>
                    </tr>`);
      }

      lines.push(`<tr><td colspan="7"/></tr>
                  <tr>
                    <td colspan="5"/>
                    <td class="text-right font-weight-bold double-line-top">${this.$number(grandTotalSale,2)}</td>
                    <td class="text-right font-weight-bold double-line-top">${this.$number(grandTotalCommission,2)}</td>
                  </tr>`);

      lines.push(`</tbody>`);
      lines.push(`</table>`);
      return lines.join('');
    },

    exportCSV() {
      const lines = [ `"${this.company.name}",,,,,`,
                      `"Sales commissions details${this.salesRepId ? `for ${this.salesReps.find(r => r.id === this.salesRepId).name}` : ''}",,,,,,`,
                      `"Sales representative / Customer","Date","Invoice","Item","Quantity","Sale","Commission"`
                    ];
      for (const salesRep of this.report) {
        let totalSale = 0;
        let totalCommission = 0;
        lines.push(`"${salesRep.salesRepName} - ${this.$number(salesRep.commissionPercent,2)}",,,,,`);

        for (const invoice of salesRep.invoices) {
          let totalInvoiceSale = 0;
          let totalInvoiceCommission = 0;
          let lineItem = `"${invoice.customerName}","${invoice.date}","${invoice.invoiceNumber}",`;
          let lineNumber = 0;
          for (const line of invoice.lines) {
//            lines.push(`${lineItem}"${line.item}",${line.quantity}`);
            totalInvoiceSale += line.amount;
            const commission = line.commissionExempt ? 0 : line.amount * salesRep.commissionPercent / 100;
            totalInvoiceCommission += commission;
            lines.push(`${lineItem}"${line.item}",${this.$number(line.product?line[this.units]:line.quantity,line.precision)},"${this.$number(line.amount,2)}","${this.$number(commission,2)}"`);
            if (lineNumber++ < invoice.lines.length-1)
              lineItem = `,,,`;
          }
          lines.push(`,,,,,"${this.$number(totalInvoiceSale,2)}","${this.$number(totalInvoiceCommission,2)}"`);
          totalSale += totalInvoiceSale;
          totalCommission += totalInvoiceCommission;
        }
        lines.push(`,,,,,"${this.$number(totalSale,2)}","${this.$number(totalCommission,2)}"`);
      }

      // Write CSV file
      const blob = new Blob([lines.join('\r\n')], {type: "text/plain;charset=utf-8"});
      fileSaver.saveAs(blob, 'Sales commissions details.csv');
    }
  }
}
</script>